export const version = '2.93.0' // bump-client-version 2026-09-18T18:38:54.926Z
